var courses = window.courses || {};

courses.filter = {
	init: function() {
		$('.filter__title', '.courses__filter').on('click', function(e) {
			var container = $(this).parent('.courses__filter');
			if (container.hasClass('filter--open')) {
				container.removeClass('filter--open');
			}
			else {
				container.addClass('filter--open');
			}
		});

		$('a', '.courses__filter').on('click', function(e) {
			var a = $(this),
				doOn = !a.hasClass('selected');

			if (a.attr('href') === '#') {
				e.preventDefault();
			}

			$('a', '.courses__filter').removeClass('selected');
			$('input[type=checkbox]', '#courses').each(function() {
				$(this).attr('checked', false);
			});

			if (doOn) {
				a.addClass('selected');
				a.find('input[type=checkbox]').attr('checked', true);
			}

			var button = $('.selected', '.courses__filter');
			if (!button.length) {
				// If nothing is selected and we have a display all button, select that
				button = $('a[rel="*"]', '.courses__filter');
				button.addClass('selected');
			}

			var rel = button.attr('rel');
			if (rel && rel !== '*') {
				if (rel.indexOf('-category-') !== -1) {
					$('.subCategory', '#courses').hide();
					$('.'+rel, '#courses').show();
				}
				else {
					var sub = $('.subCategory', '#courses');
					sub.find('.filterable').hide();

					// Show rows based on rel
					sub.find('.'+button.attr('rel')).each(function() {
						$(this).show();
					});
				}
			}
			else {
				$('.subCategory', '#courses').show();
				$('.filterable', '#courses').show();
			}
		});
	}
};